import { GetDashboard } from 'Components/dashboard/ducks/actions';
import { UpdateStockNumberAndOrVehicleId } from 'Components/vehicle/ducks/actions';
import { configureExperimentsFullstory } from '@carvana/purchase-utils';
import {
  Experiments,
  accessToken as getAccessToken
} from '@carvana/purchase-helpers';
import * as Services from '../services/index';
import { refreshTokenIfMissing } from '~/library/utils/src/axios';

const ACTION_PREPEND = 'purchase';
export const GET_CORE_CONFIG = `${ACTION_PREPEND}/GET_CORE_CONFIG`;
export const GET_USER_EXPERIMENTS = `${ACTION_PREPEND}/GET_USER_EXPERIMENTS`;

const trackUser = () => (dispatch, getState) => {
  const {
    vehicle: { stockNumber } = {},
    core: { userId, email, name, experiments } = {},
    dashboard: { status: { purchaseId } = {} } = {}
  } = getState();

  const fullstoryExperiments = configureExperimentsFullstory(experiments);

  return dispatch({
    type: '@@analytics/ANALYTICS_TRACK_USER',
    payload: Promise.resolve(),
    meta: {
      analytics: {
        type: 'trackUser',
        name: 'User Logged In',
        gtm: {
          userId
        },
        fullstory: {
          userId,
          email,
          name,
          stockNumber,
          purchaseId,
          experiments: fullstoryExperiments
        },
        clients: ['gtm', 'fullstory']
      }
    }
  });
};

export const GetUsersExperiments = () => (dispatch, getState) => {
  const { core: { userId } = {} } = getState();
  return dispatch({
    type: GET_USER_EXPERIMENTS,
    async payload() {
      const res = await Services.getUsersExperiments(userId);
      const experiments = Experiments.initialize().addExperimentList(
        res?.content
      );
      return experiments.list;
    }
  });
};

export const GetCoreConfig = () => dispatch =>
  dispatch({
    type: GET_CORE_CONFIG,
    async payload() {
      await refreshTokenIfMissing();
      const accessToken = getAccessToken();
      let { user: userInfo } = accessToken;
      const coreConfig = {
        hasProfile: userInfo?.name !== undefined,
        userId: userInfo?.sub,
        email: userInfo?.name,
        name: userInfo?.name,
        isUserBeingImpersonated: userInfo?.is_impersonating === 'True'
      };

      await dispatch(UpdateStockNumberAndOrVehicleId());

      return coreConfig;
    }
  })
    .then(async ({ value }) => {
      const { hasProfile } = value || {};

      if (hasProfile) {
        const response = await dispatch(GetDashboard());
        // eslint-disable-next-line no-param-reassign
        value.dashboard = response?.value;
      }

      return value;
    })
    .then(async value => {
      const { hasProfile, userId } = value || {};

      if (hasProfile && userId) {
        const response = await dispatch(GetUsersExperiments());
        // eslint-disable-next-line no-param-reassign
        value.experiments = response?.value;
      }

      return value;
    })
    .then(value => {
      const { hasProfile } = value || {};

      if (hasProfile) {
        dispatch(trackUser());
      }

      return value;
    });
